import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/api";

export default function WolfSearch({ tid = "wolf-search", autoFocus = false, onDone, className = "w-full sm:w-80" }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [hi, setHi] = useState(0);
  const nav = useNavigate();
  const box = useRef(null);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get("/wolf-search", { params: { q } }).then(({ data }) => { setRes(data.wolves); setHi(0); }).catch(() => {}), 200);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const out = (e) => { if (box.current && !box.current.contains(e.target)) { setRes([]); onDone?.(); } };
    document.addEventListener("mousedown", out);
    return () => document.removeEventListener("mousedown", out);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const go = (name) => { setQ(""); setRes([]); nav(`/wolf/${encodeURIComponent(name)}`); onDone?.(); };
  const key = (e) => {
    if (e.key === "Escape") return onDone?.();
    if (!res.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((hi + 1) % res.length); }
    if (e.key === "ArrowUp") { e.preventDefault(); setHi((hi - 1 + res.length) % res.length); }
    if (e.key === "Enter") go(res[hi].wolf_name);
    if (e.key === "Escape") onDone?.();
  };
  return (
    <div ref={box} className={`relative ${className}`} data-testid={tid}>
      <Search className="w-4 h-4 text-slate-500 absolute left-3.5 top-1/2 -translate-y-1/2" />
      <input data-testid={`${tid}-input`} autoFocus={autoFocus} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={key} maxLength={20} placeholder="Find a wolf by name"
        className="w-full h-11 pl-10 pr-4 rounded-full bg-[#061016] border border-slate-700 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-amber-400/70 transition-colors" />
      {q.trim().length >= 2 && (
        <div data-testid={`${tid}-results`} className="absolute z-30 mt-2 w-full rounded-2xl border border-slate-700 bg-[#081820] shadow-2xl overflow-hidden">
          {res.length ? res.map((w, i) => (
            <button key={w.wolf_name} data-testid={`${tid}-result-${i}`} onMouseEnter={() => setHi(i)} onClick={() => go(w.wolf_name)}
              className={`w-full flex items-center gap-3 px-3 py-2 text-left transition-colors ${i === hi ? "bg-amber-500/10" : ""}`}>
              <img src={w.portrait} alt="" className="w-9 h-9 rounded-lg object-cover" />
              <span className="text-sm text-white truncate flex-1">{w.wolf_name}</span>
              <span className="text-xs font-mono-game text-slate-400">Lv {w.level}</span>
            </button>
          )) : <p className="px-4 py-3 text-xs text-slate-500" data-testid={`${tid}-empty`}>No wolf starts with "{q.trim()}"</p>}
        </div>
      )}
    </div>
  );
}
